import React from "react";
import { cn } from "../lib/helpers";
import Container from "./container";
import PortableText from "./portableText";
import Button from "./button";
import Svg from 'react-inlinesvg';

import * as styles from "../styles/components/fc-content-list.module.css";

interface ImageAsset {
  asset?: {
    url?: string;
  };
}

interface ButtonType {
  blank?: boolean;
  text?: string;
  url?: string;
}

interface ContentItem {
  _key?: string;
  title?: string;
  _rawCopy?: any[];
  icon?: ImageAsset;
}

interface ContentListProps {
  title?: string;
  featuredTextStyle?: boolean;
  button?: ButtonType;
  content?: ContentItem[];
  theme?: string;
}

const ContentList: React.FC<ContentListProps> = ({
  title,
  featuredTextStyle,
  button,
  content,
  theme
}) => {
  if (!content || content.length === 0) {
    return null;
  }

  return (
    <div className={cn(styles.root, styles[theme])}>
      <Container>
        <div className="grid">
          {title  && (
            <div className="col-lg-7">
              <div className={styles.text}>
                <h2 className={cn(styles.title, featuredTextStyle && "h4")}>{title}</h2>
                <Button node={button} theme={theme} />
              </div>
            </div>
          )}

          <div className="col-lg-6 col-xl-5 offset-lg-6 offset-xl-7">
            <div className={styles.items}>
              {content.map(({ _key, title, _rawCopy, icon }) => (
                <div className={styles.item} key={_key}>
                  {icon?.asset && (
                    <Svg 
                      src={icon.asset.url}
                      uniquifyIDs={true}
                    />
                  )}

                  {(title || _rawCopy) && (
                    <div className={styles.inner}>
                      {title && (
                        <h3 className="h5">{title}</h3>
                      )}
                      {_rawCopy && (
                        <div className={cn("entry-content body-small", theme)}>
                          <PortableText blocks={_rawCopy} theme={theme} />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ContentList;
